export const enum eMapRowSettings {
    shift,
}



export class MapRowSettings {
    /**
     * (RO) Typ nastaveni
     */
    get type(): eMapRowSettings { return this._type; }
    private _type: eMapRowSettings;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: eMapRowSettings) {
        this._type = type;
    }
}



/**
 * Nastaveni pro radku, ktera v urcite vzdalenost od pozice hrace zahaji presun ze startovni pozice do cilove a cilove pozice dosahne pri urcite vzdalenosti od pozice hrace
 */
export class MapRowShiftSettings extends MapRowSettings {
    /**
     * (RO) Pocatecni pozice radky
     */
    get startPos(): number { return this._startPos; }
    private _startPos: number;

    /**
     * (RO) Cilova pozice radky
     */
    get targetPos(): number { return this._targetPos; }
    private _targetPos: number;

    /**
     * (RO) Offset od pozice hrace (na ose Z), kdy radka zahaji svuj presun
     */
    get shiftStartPlOffset(): number { return this._shiftStartPlOffset; }
    private _shiftStartPlOffset: number;

    /**
     * (RO) Offset od pozice hrace (na ose Z), kdy radka dosahne sve cilove pozice.
     * Napr.:
     * 0 = radka dosahne sve cilove pozice v moment, kdy playerZ == rowZ
     * 2 = radka dosahne sve cilove pozice v mement, kdy playerZ == rowZ + 2
     */
    get shiftEndPlOffset(): number { return this._shiftEndPlOffset; }
    private _shiftEndPlOffset: number;

    /**
     * (RO) Ease funkce pro presun
     */
    get shiftEase(): (k: number) => number { return this._shiftEase; }
    private _shiftEase: (k: number) => number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(startPos: number, targetPos: number, shiftStartPlOffset: number, shiftEndPlOffset: number, shiftEase: ((k: number) => number)) {
        super(eMapRowSettings.shift);

        this._startPos = startPos;
        this._targetPos = targetPos;
        this._shiftStartPlOffset = shiftStartPlOffset;
        this._shiftEndPlOffset = shiftEndPlOffset;
        this._shiftEase = shiftEase;
    }
}